import { DashboardWidget, LayoutConfig } from "@sanity/dashboard";
import { ValidationChecks } from "./ValidationChecks";

export function sscValidationChecksWidget(
  config: { layout?: LayoutConfig; silverseaApiRootUrl?: string } = {}
): DashboardWidget {
  return {
    name: "ssc-validation-checks",
    component: (props) => (
      <ValidationChecks
        {...props}
        silverseaApiRootUrl={config.silverseaApiRootUrl}
      />
    ),
    layout: config.layout ?? { width: "medium" }
  };
}
